import { render, staticRenderFns } from "./newwash.vue?vue&type=template&id=0b7aaa74&"
import script from "./newwash.vue?vue&type=script&lang=js&"
export * from "./newwash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports